<template>
  <div class="my-10">
    <div class="flex flex-col sm:flex-row justify-between px-4 items-center">
      <h1 class="text-3xl font-bold text-center mb-6 sm:mb-0">{{ __('Clients') }}</h1>

      <div class="flex flex-col sm:flex-row items-center flex-shrink-0">
        <div class="relative flex items-center mb-4 sm:mb-0 sm:mr-6">
          <input class="text-lg relative w-64 pl-6 pr-10 py-3 rounded-lg border border-gray-600 focus:border-coral-400 placeholder-gray-400" autocomplete="off" type="text" name="search" :placeholder="__('Search client...')" v-model="term" @keypress.enter="search">
          <div class="w-4 h-4 absolute right-0 mr-3 z-10 cursor-pointer" @click="search">
            <icon name="search" class="text-gray-600 fill-current"></icon>
          </div>
        </div>

        <div>
          <inertia-link :href="route('clients.create')" class="btn-primary">
            {{ __('Add client') }}
          </inertia-link>
        </div>
      </div>
    </div>

    <div class="bg-white p-4 shadow-md mt-10 overflow-scroll">
      <table class="w-full" v-if="clients.data.length">
        <tr class="bg-gray-700 text-gray-100">
          <th class="p-4 w-10">{{ __('Id') }}</th>
          <th class="p-4 text-left">{{ __('First name') }}</th>
          <th class="p-4 text-left">{{ __('Last name') }}</th>
          <th class="p-4 text-left">{{ __('Phone') }}</th>
          <th class="p-4 text-left">{{ __('Email') }}</th>
          <th class="p-4 text-right w-24">{{ __('Actions') }}</th>
        </tr>

        <tr v-for="(client, index) in clients.data" :class="{'bg-gray-300': index%2 === 0}">
          <td class="p-4 text-center">{{ client.id }}</td>
          <td class="p-4">
            <inertia-link :href="route('clients.edit', {client: client.id})" class="text-coral-400 hover:text-gray-500 font-semibold">{{ client.first_name }}</inertia-link>
          </td>
          <td class="p-4">{{ client.last_name }}</td>
          <td class="p-4">{{ client.phone }}</td>
          <td class="p-4">{{ client.email }}</td>
          <td class="px-4 text-center">
            <div class="flex items-center w-full justify-end">
              <inertia-link :href="route('clients.edit', {client: client.id})" class="list-edit-button mr-2">
                <icon name="edit" class="w-4 h-4 fill-current"></icon>
              </inertia-link>
              <button @click="destroy(client)" class="list-delete-button">
                <icon name="delete" class="w-4 h-4 fill-current"></icon>
              </button>
            </div>
          </td>
        </tr>
      </table>
      <div v-else>
        {{ __('No clients at the moment...') }}
      </div>
    </div>

    <pagination :links="clients.meta.links"/>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import Icon from '@/Shared/Icon';
import Pagination from '@/Shared/Pagination';
import _ from 'lodash';

export default {
  layout: Layout,
  metaInfo() {
    return {
      title: this.__('Clients'),
    };
  },
  props: {
    clients: Object,
    filters: null,
  },
  data() {
    return {
      term: this.filters.term,
    };
  },
  components: {
    Layout,
    Pagination,
    Icon,
  },
  methods: {
    search: _.throttle(function () {
      this.$inertia.get(this.route('clients.index', { 'term': this.term }), {}, { replace: true });
    }, 150),
    destroy(client) {
      if (confirm(this.__('Are you sure you want to delete client :name?', { name: client.name }))) {
        this.$inertia.delete(this.route('clients.destroy', { client: client.id }));
      }
    },
  },
};
</script>
